/* eslint-disable no-console */
import { clearAllSwatchbookData, getAllOfType } from '../swatchbook-utils';
import { login, logout, addSwatches } from './account-api';
import { launchLoginModal } from './login-modal';
import { setAfterAuthHandler } from './post-auth';

const onModalButtonClick = (event) => {
  const {
    grecaptchaApi,
    isAuthenticated,
    loginUrl,
    myAccountUrl,
  } = window;
  if (isAuthenticated) {
    return;
  }
  event.preventDefault();
  // Only launch modal if score threshold is met.
  // Otherwise should redirect to login page
  // (w/ recaptcha challenge).
  const score = grecaptchaApi.currentScore;
  if (grecaptchaApi.displayChallenge(score)) {
    window.location = loginUrl;
  } else {
    launchLoginModal({
      type: '',
      callbacks: {
        onLoginSuccess: (isNewAccount) => {
          if (isNewAccount) {
            window.location = `${myAccountUrl}?newaccount=true`;
          } else {
            window.location = myAccountUrl;
          }
        },
        onLoginFail: () => {},
      },
    });
  }
};

const onLogoutButtonClick = (event) => {
  event.preventDefault();
  logout({
    onSuccess: () => {
      clearAllSwatchbookData();
      window.location = window.loginUrl;
    },
  });
};

const addLogoutEventHandlers = () => {
  const logoutBtns = document.querySelectorAll('a[href="/logout"], a[href="/logout/"]');
  if (logoutBtns) {
    [].map.call(logoutBtns, btn => btn.addEventListener('click', onLogoutButtonClick));
  }
};

const removeModalEventHandlers = () => {
  const modalBtns = document.querySelectorAll('.acct-login-modal-btn');
  if (modalBtns) {
    [].map.call(modalBtns, btn => btn.removeEventListener('click', onModalButtonClick));
  }
};

const addModalEventHandlers = () => {
  const modalBtns = document.querySelectorAll('.acct-login-modal-btn');
  if (modalBtns) {
    [].map.call(modalBtns, btn => btn.addEventListener('click', onModalButtonClick));
  }
};

const checkLoginStatus = (callback) => {
  // console.log(`login.js, checkLoginStatus, isAuthenticated: ${window.isAuthenticated}`);
  const body = document.getElementsByTagName('body')[0];
  if (window.isAuthenticated) {
    body.classList.add('is-authenticated');
    removeModalEventHandlers();
    addLogoutEventHandlers();
    // Check to see if there are any swatches in localstorage
    const localStorageData = getAllOfType('swatch');
    if (localStorageData.length !== 0) {
      addSwatches(localStorageData, {
        onSuccess: () => {
          clearAllSwatchbookData();
          if (callback) {
            callback();
          }
        },
        onError: () => {
          if (callback) {
            callback();
          }
        },
      });
    } else if (callback) {
      callback();
    }
  } else {
    body.classList.remove('is-authenticated');
    // Do not add unless recaptcha threshold score is met
    addModalEventHandlers();
  }
};

const submitForm = (data, callbacks) => {
  login(data, callbacks);
};

// Wire the swatchbook-aware post-auth behavior into the shared post-auth seam
// so that a modal login OR an account creation still merges any locally-saved
// swatches into the account. Keeping this here (rather than in login-modal.js /
// create-account.js) is what lets those UI modules stay free of the
// swatchbook/localStorage subsystem.
setAfterAuthHandler(checkLoginStatus);

const init = () => {
  checkLoginStatus();
};

export {
  checkLoginStatus,
  init,
  launchLoginModal,
  submitForm,
};
/* eslint-enable no-console */
